import PropTypes from "prop-types"
import React, { useEffect, useRef } from "react"

// //Import Scrollbar
import SimpleBar from "simplebar-react"

// MetisMenu
import MetisMenu from "metismenujs"
import { withRouter } from "react-router-dom"
import { Link } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"
import { SidementContent, sidementfilter, REPORT_KEY_TO_MENU } from "common/SidementContent"
import { useSelector } from 'react-redux';

const SidebarContent = (props: any) => {
  const ref = useRef<any>(null);
  const selectedFactory = useSelector((state: any) =>  state.factory.selected);
  const currentUser = useSelector((state: any) => state.user && state.user.user);
  // A "View & Validate" user also sees the tabs for the reports they can validate
  // (from the factory's Validation config), on top of their own report permissions.
  const _perm: string[] = (selectedFactory && selectedFactory.permission) || [];
  let _extraKeys: string[] = [];
  if (_perm.includes("VALIDATE") && !_perm.includes("ADMIN")) {
    const _cfg = ((selectedFactory && selectedFactory.validationConfig) || [])
      .find((c: any) => String(c.userId) === String(currentUser && currentUser._id));
    _extraKeys = (((_cfg && _cfg.reports) || []) as string[])
      .map((r) => REPORT_KEY_TO_MENU[r])
      .filter(Boolean);
  }
  const sidemenu = sidementfilter(selectedFactory && selectedFactory.permission, _extraKeys);

  // Super Admin (global) and Org/Factory Admin (ADMIN on the selected factory)
  // get the Dashboard pinned ABOVE the "MENU" heading; every other user keeps
  // Dashboard as a normal item listed UNDER "MENU".
  const isAdmin =
    !!(currentUser && currentUser.superAdmin) ||
    !!(selectedFactory && selectedFactory.permission && selectedFactory.permission.includes("ADMIN"));
  const dashboardItem: any = sidemenu.find((m: any) => m.path === "/dashboard");
  const menuItems = isAdmin
    ? sidemenu.filter((m: any) => m.path !== "/dashboard")
    : sidemenu;
  // Use ComponentDidMount and ComponentDidUpdate method symultaniously
  useEffect(() => {
    const pathName = props.location.pathname
    const menu = new MetisMenu("#side-menu")
    let matchingMenuItem: any = null
    const ul = document.getElementById("side-menu")
    const items = ul!.getElementsByTagName("a")
    for (let i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i]
        break
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem)
    }
    // dispose so stale listeners from a previous render become no-ops;
    // re-init when the menu list changes (factory/permission switch)
    return () => { menu.dispose() }
  }, [props.location.pathname, selectedFactory])

  useEffect(() => {
    ref.current.recalculate()
  })

  function scrollElement(item: any) {
    if (item) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }

  function activateParentDropdown(item: any) {
    item.classList.add("active")
    const parent = item.parentElement
    const parent2El = parent.childNodes[1]
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show") // ul tag

        const parent3 = parent2.parentElement // li tag

        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.childNodes[0].classList.add("mm-active") //a
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              parent5.childNodes[0].classList.add("mm-active") // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false
    }
    scrollElement(item);
    return false
  }

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            {isAdmin && dashboardItem && (
              <li className="mw-pinned-item">
                <Link to={dashboardItem.path ?? '#'}>
                  <i className={dashboardItem.icon}></i>
                  <span>{props.t(dashboardItem.label)}</span>
                </Link>
              </li>
            )}
            <li className="menu-title">{props.t("Menu")} </li>

            {
              menuItems.map((m, mIndex) => {
                return (
                  <li key={mIndex}>
                    <Link to={m.path ?? '#'} className={(m.list) ? "has-arrow" : ''}>
                      <i className={m.icon}></i>
                      <span>{props.t(m.label)}</span>
                    </Link>
                    {
                      m.list && <ul className="sub-menu" aria-expanded="false">
                        {
                          m.list.map((m1, m1Index) => {
                            return (<li key={m1Index}>
                              <Link to={m1.path}>{props.t(m1.label)}</Link>
                            </li>)
                          })
                        }
                      </ul>
                    }
                  </li>
                )
              })
            }
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter<any, any>(withTranslation()(SidebarContent))
